"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePubSubEvent = exports.PubSub = void 0;
var react_1 = require("react");
var DEBUG = false;
var PubSub = (function () {
    function PubSub() {
    }
    PubSub.subscribe = function (event, handler) {
        if (typeof document === "undefined") {
            return function () { };
        }
        var handleEvent = function (ev) {
            handler(ev.detail);
        };
        document.addEventListener(event, handleEvent);
        return function () {
            document.removeEventListener(event, handleEvent);
        };
    };
    PubSub.publish = function (event, data) {
        if (DEBUG) {
            console.log("PubSub: \"".concat(event, "\" %O"), data);
        }
        document.dispatchEvent(new CustomEvent(event, { detail: data }));
    };
    return PubSub;
}());
exports.PubSub = PubSub;
var usePubSubEvent = function (event, def) {
    var _a = __read((0, react_1.useState)(def), 2), eventDetail = _a[0], setEventDetail = _a[1];
    (0, react_1.useEffect)(function () {
        return PubSub.subscribe(event, function (data) { return setEventDetail(data); });
    }, [event]);
    return [eventDetail, function (data) { return PubSub.publish(event, data); }];
};
exports.usePubSubEvent = usePubSubEvent;
